<ion-content class="ion-padding">
  <div class="ion-display-flex ion-flex-column ion-justify-content-center h-100">
    <ion-text color="dark">
      <h2 class="ion-text-center">Atualização necessária</h2>
    </ion-text>

    <ion-text color="medium">
      <p class="ion-text-center">
        Uma nova versão do aplicativo está disponível. Por favor, atualize para
        continuar usando o Tarraf Imobiliária.
      </p>
    </ion-text>

    <ion-button
        (click)="openStore()"
        class="ion-margin-top"
        expand="block"
    >
      Atualizar agora
    </ion-button>
  </div>
</ion-content>
